// extracted by mini-css-extract-plugin
module.exports = {"check":"styles_check__KO3m6"};